<template>
  <div>
    <div class="button" @click="print">
      <a-icon type="printer" style="font-size: 18px" />
      <div>打印地图</div>
    </div>
  </div>
</template>

<script>
import domtoimage from "dom-to-image";
import { saveAs } from "file-saver";
export default {
  data() {
    return {};
  },
  methods: {
    print() {
      // window.print();

      const node = document.getElementById("map");
      // const node = document.getElementsByTagName("body")[0];
      console.log("print", node);
      if (!node) return;
      const that = this;
      domtoimage
        .toPng(node)
        .then(function (dataUrl) {
          console.log("dataurl", dataUrl);
          saveAs(dataUrl, "map.png");
          // that.$message.success("打印成功");
        })
        .catch(function (error) {
          console.error("oops, something went wrong!", error);
          that.$message.error("打印失败");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.button {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: #999;
  font-size: 12px;
}
</style>